import {createReducer} from '@reduxjs/toolkit'
import {RsvpStatus} from '@wix/events-types'
import {AnyAction} from 'redux'
import {
  CHANGE_RESPONSE_OLD,
  EDIT_RSVP_STEP_OLD,
  NEXT_RSVP_STEP_OLD,
  SET_RSVP_DETAILS_OLD,
  changeResponse,
  editRsvpStep,
  nextStep,
  setRsvpDetails,
} from '../actions/rsvp'
import {RSVP_STEPS} from '../constants/constants'
import {RsvpState} from '../types/state'

const defaultState: RsvpState = {
  currentStep: RSVP_STEPS[0],
  rsvpDetails: null,
  response: RsvpStatus.YES,
}

export const rsvp = createReducer(defaultState, builder => {
  builder
    .addCase(SET_RSVP_DETAILS_OLD, (state, action: AnyAction) => {
      state.rsvpDetails = action.payload.rsvpDetails
    })
    .addCase(setRsvpDetails, (state, action) => {
      state.rsvpDetails = action.payload
    })
    .addCase(NEXT_RSVP_STEP_OLD, (state, action: AnyAction) => {
      state.currentStep = action.payload.nextStep
    })
    .addCase(nextStep.fulfilled, (state, action) => {
      state.currentStep = action.payload.nextStep
    })
    .addCase(EDIT_RSVP_STEP_OLD, (state, action: AnyAction) => {
      state.currentStep = action.payload.currentStep
    })
    .addCase(editRsvpStep, (state, action) => {
      state.currentStep = action.payload
    })
    .addCase(CHANGE_RESPONSE_OLD, (state, action: AnyAction) => {
      state.response = action.payload.response
    })
    .addCase(changeResponse, (state, action) => {
      state.response = action.payload
    })
})
